'use strict';
var frontendUtils = require('honda_cars_ecux/utils/frontendUtils');

const configuratorDownloadBrochure = {
    setDownloadBrochureVisibility: function (disableDownloadBrochure) {
        var $downloadBrochurModalTrigger = $('.download-brochure-modal__trigger');
        var $navBrochure = $('.configurator-modal .list-group-item-action[data-view="view-brochure"]');

        if (disableDownloadBrochure) {
            $downloadBrochurModalTrigger.attr('disabled', 'disabled');
            $downloadBrochurModalTrigger.addClass('download-brochure-modal__trigger--disabled');
            $downloadBrochurModalTrigger.parent().addClass('d-none');
            $downloadBrochurModalTrigger.parent().removeClass('d-flex');
            $navBrochure.addClass('d-none disabled').attr('aria-disabled', 'true');
        } else {
            $downloadBrochurModalTrigger.removeAttr('disabled');
            $downloadBrochurModalTrigger.removeClass('download-brochure-modal__trigger--disabled');
            $downloadBrochurModalTrigger.parent().removeClass('d-none');
            $downloadBrochurModalTrigger.parent().addClass('d-flex');
            $navBrochure.removeClass('d-none disabled').removeAttr('aria-disabled');
        }
    },
    setupPageListeners: function () {
        var setDownloadBrochureVisibility = this.setDownloadBrochureVisibility;
        $('body').on('product:afterAttributeSelect', function (el, response) {
            setDownloadBrochureVisibility(response.data.product.customProps.disableDownloadBrochure);
        });
        $('body').on('click', '.download-brochure-modal__trigger', function (e) {
            e.preventDefault();
            var $flyout = $('.configurator-modal');
            var $downloadBrochure = $('.configurator-modal .list-group-item-action[data-view="view-brochure"]').first();

            if ($flyout.length && $downloadBrochure.length) {
                if (!$flyout.hasClass('show')) {
                    $flyout.modal('show');
                }
                // Synthetic click on the side-sheet item. Tag it so click_cta
                // uses in-page, not three-dots. .click() is synchronous.
                var menuItem = $downloadBrochure[0];
                menuItem.dataset.analyticsLocation = 'in-page';
                menuItem.click();
                delete menuItem.dataset.analyticsLocation;
                return;
            }
        });
    },
    init: function () {
        this.setupPageListeners();
    }
}

module.exports = configuratorDownloadBrochure;
